import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {GeneralHttpHelperService} from '../../helpers/general-http-helper.service';
import {HttpClient} from '@angular/common/http';

const NOTIFICATION_API_ROUTES = {
  GET_SUPPORT: 'admin/change-requests',
  POST_SUPPORT_READ_NOTIFICATION: 'admin/change-requests/:notificationId/read',
  GET_CUSTOM_NOTIFICATION: 'admin/custom-notifications',
  CREATE_CUSTOM_NOTIFICATION: 'admin/custom-notifications',
  EDIT_CUSTOM_NOTIFICATION: 'admin/custom-notifications/:notificationId',
  GET_USERS_NOTIFICATIONS: 'admin/notifications-users',
  POST_USERS_READ_NOTIFICATION: 'admin/notifications-users/:notificationId/read',
  POST_BUSINESS_READ_NOTIFICATION: 'admin/notifications-business-users/:notificationId/read',
  GET_RESERVATIONS_NOTIFICATIONS: 'admin/notifications-reservations-gifts',
  POST_RESERVATIONS_READ_NOTIFICATION: 'admin/notifications-reservations/:notificationId/read',
  GET_ALL_NOTIFICATIONS_COUNT: 'admin/all-notifications-count',
  GET_BUSINESS_NOTIFICATIONS_COUNT: 'admin/notifications-business-users',
};
@Injectable({
  providedIn: 'root'
})
export class NotificationsHttpService {

  constructor(private generalHttpHelperService: GeneralHttpHelperService,
              private httpClient: HttpClient) { }
  private getSupportNotificationsReq(urlParams: any): Observable<any> {
    const apiUrl = this.generalHttpHelperService.addUrlParams(NOTIFICATION_API_ROUTES.GET_SUPPORT, urlParams);
    return this.httpClient.get(apiUrl) as any;
  }

  getSupportNotifications(urlParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getSupportNotificationsReq(urlParams).subscribe((res: any) => {
        resolve(
          {
            data: res.data.data,
            pagination: this.generalHttpHelperService.returnPagination(res.data),
            unreadCount: res.unread_count
          }
        );
      }, error => {
        reject(error);
      });
    });
  }

  private postSupportReadNotificationReq(urlParams: any): Observable<any> {
    const url = this.generalHttpHelperService.replaceUrlParamsWithValues(NOTIFICATION_API_ROUTES.POST_SUPPORT_READ_NOTIFICATION, urlParams);
    return this.httpClient.post(url, {}) as any;
  }

  postSupportReadNotification(urlParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.postSupportReadNotificationReq(urlParams).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private getCustomNotificationsReq(urlParams: any): Observable<any> {
    const apiUrl = this.generalHttpHelperService.addUrlParams(NOTIFICATION_API_ROUTES.GET_CUSTOM_NOTIFICATION, urlParams);
    return this.httpClient.get(apiUrl) as any;
  }

  getCustomNotifications(urlParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getCustomNotificationsReq(urlParams).subscribe((res: any) => {
        resolve(
          {
            data: res.data.data,
            pagination: this.generalHttpHelperService.returnPagination(res.data)
          }
        );
      }, error => {
        reject(error);
      });
    });
  }

  private createCustomNotificationReq(bodyParams: any): Observable<any> {
    return this.httpClient.post(NOTIFICATION_API_ROUTES.CREATE_CUSTOM_NOTIFICATION, bodyParams) as any;
  }

  createCustomNotification(bodyParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.createCustomNotificationReq(bodyParams).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private editCustomNotificationReq(urlParams: any, bodyParams: any): Observable<any> {
    const apiUrl = this.generalHttpHelperService.replaceUrlParamsWithValues(NOTIFICATION_API_ROUTES.EDIT_CUSTOM_NOTIFICATION, urlParams);
    return this.httpClient.post(apiUrl, bodyParams) as any;
  }

  editCustomNotification(urlParams: any, bodyParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.editCustomNotificationReq(urlParams, bodyParams).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private getUsersNotificationsReq(urlParams: any): Observable<any> {
    const apiUrl = this.generalHttpHelperService.addUrlParams(NOTIFICATION_API_ROUTES.GET_USERS_NOTIFICATIONS, urlParams);
    return this.httpClient.get(apiUrl) as any;
  }

  getUsersNotifications(urlParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getUsersNotificationsReq(urlParams).subscribe((res: any) => {
        resolve({
          data: res.notifications.data,
          unreadCount: res.unread_count,
          pagination: this.generalHttpHelperService.returnPagination(res.notifications)
        });
      }, error => {
        reject(error);
      });
    });
  }

  private postUsersReadNotificationReq(urlParams: any): Observable<any> {
    const url = this.generalHttpHelperService.replaceUrlParamsWithValues(NOTIFICATION_API_ROUTES.POST_USERS_READ_NOTIFICATION, urlParams);
    return this.httpClient.post(url, {}) as any;
  }

  postUsersReadNotification(urlParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.postUsersReadNotificationReq(urlParams).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private postBusinessUsersReadNotificationReq(urlParams: any): Observable<any> {
    const url = this.generalHttpHelperService.replaceUrlParamsWithValues(NOTIFICATION_API_ROUTES.POST_BUSINESS_READ_NOTIFICATION, urlParams);
    return this.httpClient.post(url, {}) as any;
  }

  postBusinessUsersReadNotification(urlParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.postBusinessUsersReadNotificationReq(urlParams).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private getReservationsNotificationsReq(urlParams: any): Observable<any> {
    const apiUrl = this.generalHttpHelperService.addUrlParams(NOTIFICATION_API_ROUTES.GET_RESERVATIONS_NOTIFICATIONS, urlParams);
    return this.httpClient.get(apiUrl) as any;
  }

  getReservationsNotifications(urlParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getReservationsNotificationsReq(urlParams).subscribe((res: any) => {
        resolve({
          data: res.notifications.data,
          unreadCount: res.unread_count,
          pagination: this.generalHttpHelperService.returnPagination(res.notifications)
        });
      }, error => {
        reject(error);
      });
    });
  }

  private postReservationsReadNotificationReq(urlParams: any): Observable<any> {
    const url = this.generalHttpHelperService.replaceUrlParamsWithValues(NOTIFICATION_API_ROUTES.POST_RESERVATIONS_READ_NOTIFICATION, urlParams);
    return this.httpClient.post(url, {}) as any;
  }

  postReservationsReadNotification(urlParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.postReservationsReadNotificationReq(urlParams).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private getAllNotificationsCountReq(): Observable<any> {
    return this.httpClient.get(NOTIFICATION_API_ROUTES.GET_ALL_NOTIFICATIONS_COUNT) as any;
  }

  getAllNotificationsCount(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getAllNotificationsCountReq().subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private getBusinessNotificationsCountReq(): Observable<any> {
    return this.httpClient.get(NOTIFICATION_API_ROUTES.GET_BUSINESS_NOTIFICATIONS_COUNT) as any;
  }

  getBusinessNotificationsCount(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getBusinessNotificationsCountReq().subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }
}
